import { createRecipe } from './runtime';

const avatarConfig = {"name":"avatar","defaultVariants":{"size":"md","tone":"steel"},"variantMap":{"size":["md","sm","xs"],"tone":["deny","muted","steel"]}}

export const avatar = /* @__PURE__ */ createRecipe(avatarConfig)